import request from '../utils/request';

export interface ServerMessage {
  id: number;
  conv_id?: number;
  conversation_id?: number;
  user_id: number | null;
  role: 'user' | 'assistant';
  content: string;
  create_time?: string;
  created_at?: string;
}

/**
 * 获取指定对话的消息列表
 */
export const getMessagesByConversationId = async (
  conversationId: string | number,
  limit = 100,
  offset = 0
): Promise<{ messages: ServerMessage[] }> => {
  const res = await request.get(`/messages/conversation/${conversationId}`, {
    params: { limit, offset },
  });
  const data = res?.data ?? res;
  const messages = data?.messages ?? data?.data?.messages ?? [];
  return { messages };
};
